<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <label class="form-label">
        Название
        <span class="required">*</span>
      </label>
      <input
        v-model="localData.name"
        class="form-select"
        :class="{ invalid: errors.name }"
        placeholder="Например: Собственный"
        @input="errors.name = false"
      />
      <span v-if="errors.name" class="error-message">
        Обязательное поле
      </span>
    </div>

    <div class="form-group">
      <label class="form-label">Цвет</label>
      <div class="color-picker-wrapper">
        <input
          type="color"
          v-model="localData.color"
          class="color-picker"
        />
        <input
          v-model="localData.color"
          class="form-select color-input"
          placeholder="#22c55e"
        />
      </div>
    </div>

    <div class="form-actions">
      <base-primary-button type="submit" :disabled="isLoading">
        <span v-if="isLoading">Сохранение...</span>
        <span v-else>Сохранить</span>
      </base-primary-button>
      <base-button type="button" @click="$emit('cancel')">
        Отмена
      </base-button>
    </div>
  </form>
</template>

<script>
import { generateUniqueCode } from "@/utils/codeGenerator";

export default {
  name: "ReferenceItemForm",
  props: {
    initialData: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    existingItems: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["save", "cancel"],
  data() {
    return {
      localData: {
        name: "",
        code: "",
        color: "#22c55e",
      },
      errors: {
        name: false,
      },
    };
  },
  watch: {
    "localData.name"(newName) {
      if (!this.initialData) {
        this.localData.code = generateUniqueCode(
          newName,
          this.existingItems
        );
      }
    },
  },
  created() {
    if (this.initialData) {
      this.localData = {
        name: this.initialData.name || "",
        code: this.initialData.code || "",
        color: this.initialData.color || "#22c55e",
      };
    }
  },
  methods: {
    validate() {
      let isValid = true;
      if (!this.localData.name.trim()) {
        this.errors.name = true;
        isValid = false;
      }
      return isValid;
    },

    handleSubmit() {
      if (!this.validate()) return;

      this.$emit("save", {
        name: this.localData.name.trim(),
        code: this.localData.code.trim(),
        color: this.localData.color || null,
      });
    },
  },
};
</script>

<style scoped>
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.required {
  color: var(--color-danger);
}

.error-message {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: var(--color-danger);
}

.color-picker-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.color-picker {
  width: 40px;
  height: 38px;
  border: 1px solid #999;
  border-radius: 6px;
  cursor: pointer;
  padding: 2px;
  flex-shrink: 0;
}

.color-input {
  flex: 1;
  font-family: "Menlo", "Monaco", "Courier New", monospace;
  font-size: 13px;
}
</style>
